import React from 'react';

/**
 * DesignArtboard — labeled card container for a single artboard.
 * Label sits above; white card with shadow below.
 */
/**
 * DesignArtboard — labeled card container for a single artboard.
 *
 * `overlay` prop renders a div absolutely over the card content (pointer-events: none
 * by default so individual overlay children can opt-in with pointerEvents: 'auto').
 */
const DesignArtboard = ({ label, width, height, children, overlay, style }) => {
  return (
    <div style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center', ...style }}>
      {label && (
        <div
          style={{
            fontSize: 11,
            fontWeight: 500,
            color: '#999',
            letterSpacing: '0.04em',
            textTransform: 'uppercase',
            marginBottom: 8,
            userSelect: 'none',
          }}
        >
          {label}
        </div>
      )}
      <div
        style={{
          position: 'relative',
          width: width || 390,
          height: height || 'auto',
          background: '#ffffff',
          borderRadius: 16,
          boxShadow: '0 4px 24px rgba(0,0,0,0.12), 0 1px 4px rgba(0,0,0,0.06)',
          overflow: 'hidden',
          flexShrink: 0,
        }}
      >
        {children}
        {overlay && (
          <div
            style={{
              position: 'absolute',
              inset: 0,
              pointerEvents: 'none',
              zIndex: 10,
            }}
          >
            {overlay}
          </div>
        )}
      </div>
    </div>
  );
};

export default DesignArtboard;
